export default __webpack_public_path__ + "static/media/faceBlack.8988a5ad.svg";